import script from "./ProjectCompletedLifecycleSetter.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProjectCompletedLifecycleSetter.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__